import * as moment from 'moment';

export class QuizQuestionAnswer {
    id: number;
    question_id: number;
    answer: string;
    updated_at: moment.Moment;
    created_at: moment.Moment;
    constructor(answer?) {
        if (answer) {
            this.id = answer.id;
            this.question_id = answer.question_id;
            this.answer = answer.answer;
            this.created_at = moment(answer.created_at);
            this.updated_at = moment(answer.updated_at);
        }
    }
}
